import React from "react";
import  ReactDOM  from "react-dom";



function Intro(){
    return(
       
<div  className="introduction ">
     
  
       <div className="intro intro-text">
           <h2 id="intro-head" className="heading">Hi there,I am Siya Vats</h2>
           <h3 className="heading">Passionate Learner | Frontend-developer</h3>
           <button className=" intro-btn heading" type="submit"><a href="#myContact">Contact Me</a></button>
            
      </div>
       
     
     <div className="intro intro-img">
       <img className="profile-img"  src="./image/profile.jpg"></img>
       
    </div>
</div>
  
);

}

export default Intro;